import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import FormDevelopment from '@components/developmentContact/2'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const FormDevelopment_3 = ({
  title,
  paragraph,
  button,
  underlineMode,
  developmentID,
  titleSecondary,
  titleElement,
  global_data,
  customBorderRadius,
}: CombinedProps) => {
  return (
    <FormDevelopment
      title={title}
      paragraph={paragraph}
      button={button}
      underlineMode={underlineMode}
      developmentID={developmentID}
      titleSecondary={titleSecondary}
      titleElement={titleElement}
      global_data={global_data}
      customBorderRadius={customBorderRadius}
    />
  )
}

export default FormDevelopment_3
